export default __webpack_public_path__ + "static/media/team58.9631b54c.JPG";